// extracted by mini-css-extract-plugin
module.exports = {"chatMarkdown":"ChatMarkdown_chatMarkdown__8lra7","highlightedCode":"ChatMarkdown_highlightedCode__H6UCy"};